import { observer } from "mobx-react-lite";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import useThemeService from "../../services/theme-service/ThemeService";
import Svg from "../svg/Svg";
import { SmartAppsWhite } from "../svg/svgImageList";
import BreadcrumbItem from "./BreadcrumbItem";
import usePageTitle from "../../services/page-title/PageTitleKey";
import useRouteService from "../../services/route-service/RouteService";
import { Breadcrumb } from "../../services/breadcrumbs/BreadcrumbModel";
import { breadcrumbsStorage } from "../../services/breadcrumbs/BreadcrumbsStorage";
import { MainMenuItemCategory } from "../../services/main-menu/MainMenuService";
import { useLocation } from "react-router-dom";

export interface IBreadcrumbProps {
  title?: string;
  menuCategories: MainMenuItemCategory[];
}

export default observer(function Breadcrumbs(props: IBreadcrumbProps) {
  const { pathname } = useLocation();
  const { theme, themeClass } = useThemeService();
  const { pageTitleKey, pageTitleContext } = usePageTitle();
  const { isUserOnProjects, isUserOnJobs } = useRouteService();
  const [menuCategoryName, setMenuCategoryName] = useState("");
  const [menuCategoryPath, setMenuCategoryPath] = useState("");
  const path = useMemo(() => pathname.split("/"), [pathname]);

  const getBreadcrumbTextKey = useCallback(() => {
    return menuCategoryName && `general.${menuCategoryName}`;
  }, [menuCategoryName]);

  const getPageNameKey = useCallback(() => {
    return getBreadcrumbTextKey() === pageTitleKey ? "" : pageTitleKey;
  }, [getBreadcrumbTextKey, pageTitleKey]);

  const getPageNameContext = useCallback(() => {
    return getBreadcrumbTextKey() === pageTitleKey ? undefined : pageTitleContext;
  }, [getBreadcrumbTextKey, pageTitleContext, pageTitleKey]);

  useEffect(() => {
    const mainMenuItemFromPath =
      props.menuCategories.find((x) => path.includes(x.name)) ||
      props.menuCategories.find((x) => x.aliases && x.aliases.some((a) => path.includes(a)));

    if (mainMenuItemFromPath) {
      setMenuCategoryName(mainMenuItemFromPath.name);
      setMenuCategoryPath(mainMenuItemFromPath.path || mainMenuItemFromPath.name);
    } else {
      setMenuCategoryName(path[1] || "");
      setMenuCategoryPath(path[1] || "");
    }
  }, [window.location.pathname, props.menuCategories, path]);

  return (
    <div className={themeClass(["navbar-breadcrumb"])}>
      <NavLink to="/">
        <div className="nav-div">
          <Svg svg={SmartAppsWhite} className="esic-logo" />
        </div>
      </NavLink>
      {isUserOnProjects() || isUserOnJobs() ? (
        breadcrumbsStorage.breadcrumbs.map((breadcrumb: Breadcrumb, index) => (
          <BreadcrumbItem
            key={index}
            textKey={breadcrumb.textKey}
            to={breadcrumb.to}
            textContext={breadcrumb.textContext}
            isEllipsis={breadcrumb.isEllipsis}
          />
        ))
      ) : (
        <>
          <BreadcrumbItem textKey={getBreadcrumbTextKey()} to={`${menuCategoryPath}`} />
          <BreadcrumbItem textKey={getPageNameKey()} textContext={getPageNameContext()} />
        </>
      )}
    </div>
  );
});
